import { registerTestTour } from '@/composables/tourTestRun'
import { createApp } from 'vue'
import withUUID from 'vue-uuid'

import 'vuetify/styles'
import '@fortawesome/fontawesome-pro/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'driver.js/dist/driver.css'

import '@/plugins/validate/index'

import App from '@/App.vue'

import { registerGlobalComponents } from '@/components'
import { registerPlugins } from '@/plugins'
import { createVuetifyInstance } from '@/plugins/vuetify/index'
import { registerGlobalProperties } from './globalProperties'
import { router } from '@/plugins/router/index'
import { useInitStore } from '@/stores'

async function ensureInitialized() {
	const initStore = useInitStore()
	if (initStore.initialized) return
	try {
		await initStore.ensureInitialized()
		return
	} catch (error) {
		throw new Error(`Failed to initialize stores: ${error}`)
	}
}

function clearSessionStorage() {
	sessionStorage.removeItem('user')
}

function init() {
	try {
		// Create Vue app instance
		const app = withUUID(createApp(App))

		// Register plugins and components
		registerPlugins(app)
		registerGlobalComponents(app)
		registerGlobalProperties(app)
		window.addEventListener('beforeunload', clearSessionStorage)

		// Initialize Vuetify (this also ensures stores are initialized)
		createVuetifyInstance().then((vuetify) => {
			app.use(vuetify)
			ensureInitialized().then(() => {
				// Set up router (login guard will handle store initialization)
				app.use(router)
				app.mount('#app')
				// Test-Tour für Entwicklung und Cypress (AAR-1993); sonst ohne Wirkung.
				registerTestTour()
			})
		})

		// Get the initialization store
	} catch (error) {
		console.error('Application initialization failed:', error)

		// Fallback error handling
		const errorApp = createApp({
			template: `
        <div class="error-container">
          <h1>Application Error</h1>
          <p>There was a problem loading the application. Please try again later.</p>
        </div>
      `,
			style: `
        .error-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100vh;
          font-family: sans-serif;
        }
      `,
		})

		errorApp.mount('#app')
	}
}

// Start the application
init()
